import api from '@/configs/GlobalRequestHandler.js';

export default {
  listAdmin: () => api.getRequest('/admin/announcements'),
  create: (body) => api.postRequestWithBody('/admin/announcements', body),
  update: (id, body) => api.putRequestWithBody(`/admin/announcements/${id}`, body),
  list: () => api.getRequest('/announcements'),
  unreadCount: () => api.getRequest('/announcements/unread-count'),
  markRead: (id) => api.postRequest(`/announcements/${id}/read`),
  markAllRead: () => api.postRequest('/announcements/read-all'),
};
